import { Injectable, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResult } from '../../models/api-result.models';

export interface UpdateTelegramInfoRequest {
    readonly telegram_chat_id: string;
    readonly telegram_bot_token: string;
}

interface TelegramGetUpdatesResponse {
    readonly ok?: boolean;
    readonly result: ReadonlyArray<{
        readonly message: {
            readonly chat: {
                readonly id: number;
            };
        };
    }>;
}

export interface AlterarSenhaRequest {
    readonly senha_atual: string;
    readonly senha_nova: string;
    readonly repetir_senha_nova: string;
}

export interface RecuperarSenhaRequest {
    readonly email: string;
}

@Injectable({
    providedIn: 'root',
})
export class ClienteService {
    public urlBase = environment.urlApi;

    private readonly httpClient = inject(HttpClient);

    public updateTelegramInfo(request: UpdateTelegramInfoRequest): Observable<ApiResult> {
        const { telegram_chat_id, telegram_bot_token } = request;
        return this.httpClient.put<ApiResult>(this.urlBase + '/cliente', { telegram_chat_id, telegram_bot_token });
    }

    public getChatIDFromToken(token: string = ''): Observable<TelegramGetUpdatesResponse> {
        return this.httpClient.get<TelegramGetUpdatesResponse>(`https://api.telegram.org/bot${token}/getUpdates`);
    }

    public alterarSenha(request: AlterarSenhaRequest): Observable<ApiResult> {
        return this.httpClient.post<ApiResult>(this.urlBase + '/alterar-senha', request);
    }

    public recuperarSenha(request: RecuperarSenhaRequest): Observable<ApiResult> {
        return this.httpClient.post<ApiResult>(this.urlBase + '/recuperar-senha', request);
    }

    public getClienteByIdSite(id: number): Observable<ApiResult> {
        return this.httpClient.get<ApiResult>(`${this.urlBase}/cliente/${id}`);
    }

    public updateVsualizouTermosUso(): Observable<ApiResult> {
        return this.httpClient.put<ApiResult>(this.urlBase + '/cliente/visualizou-termos', {});
    }
}
